"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactI18next = require("react-i18next");
var _utils = require("../../../../utils");
var _hooks = require("../../../../hooks");
var _ui = require("../../../ui");
var _transactionInfo = require("./transaction-info");
var _BalanceName = require("./BalanceName");
var _TwoFactorForm = require("./TwoFactorForm");
var _exchange = require("../exchange");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var ModalBody = (0, _styledComponents.default)(_ui.ModalBody)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 20px 20px 30px;\n  ", "\n"])), _utils.mediaQuery.lessThan('sm')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: 0 10px 40px;\n  "]))));
var TotalAmount = (0, _styledComponents.default)(_transactionInfo.TransactionInfoTotalAmount)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin: 20px 0;\n"])));
var StyledAlert = (0, _styledComponents.default)(_ui.Alert)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-top: 28px;\n  margin-bottom: 20px;\n"])));
var Button = (0, _styledComponents.default)(_ui.Button)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-bottom: 20px;\n"])));
var ConfirmModal = function ConfirmModal(_ref) {
  var withdraw2faEnabled = _ref.withdraw2faEnabled,
    balanceName = _ref.balanceName,
    children = _ref.children,
    ToComponent = _ref.toComponent;
  var _useTranslation = (0, _reactI18next.useTranslation)(['libTransfers', 'libCommon', 'libAuth']),
    t = _useTranslation.t;
  var props = (0, _hooks.useWithdrawContext)();

  // TODO convert already enabled, withdraw context empty (move to separate ctx later)
  if (!props.mode) return /*#__PURE__*/_react.default.createElement(_exchange.ExchangeConfirmModal, {
    withdraw2faEnabled: withdraw2faEnabled,
    balanceName: balanceName,
    toComponent: ToComponent
  }, children);
  return /*#__PURE__*/_react.default.createElement(_ui.Modal, {
    isOpen: props.modalOpen,
    toggle: props.toggleModal
  }, /*#__PURE__*/_react.default.createElement(_ui.ModalHeader, {
    toggle: props.toggleModal
  }, t('sendingConfirmation')), /*#__PURE__*/_react.default.createElement(ModalBody, null, /*#__PURE__*/_react.default.createElement(_transactionInfo.TransactionInfoItem, {
    title: t('from')
  }, /*#__PURE__*/_react.default.createElement(_BalanceName.BalanceName, {
    ticker: props.ticker,
    value: balanceName
  })), /*#__PURE__*/_react.default.createElement(_transactionInfo.TransactionInfoItem, {
    title: t('to')
  }, ToComponent ? /*#__PURE__*/_react.default.createElement(ToComponent, null) : /*#__PURE__*/_react.default.createElement("span", {
    className: "text-truncate"
  }, props.address)), !props.isFiat && /*#__PURE__*/_react.default.createElement(_transactionInfo.TransactionInfoItem, {
    title: t('network')
  }, /*#__PURE__*/_react.default.createElement("span", null, t('blockchains.' + props.blockchain), " ", t('network'))), /*#__PURE__*/_react.default.createElement(_transactionInfo.TransactionInfoAmountItem, {
    title: t('amount'),
    ticker: props.ticker,
    fiatTicker: props.fiatTicker,
    amount: props.amount,
    fiatTickerAmount: props.fiatTickerAmount
  }), /*#__PURE__*/_react.default.createElement(_transactionInfo.TransactionInfoAmountItem, {
    title: t('serviceFee'),
    ticker: props.ticker,
    fiatTicker: props.fiatTicker,
    amount: props.fee,
    fiatTickerAmount: props.fiatTickerFee,
    className: "mb-0"
  }), /*#__PURE__*/_react.default.createElement(TotalAmount, {
    ticker: props.ticker,
    convertedTicker: props.fiatTicker,
    amount: props.total,
    convertedAmount: props.fiatTickerTotal
  }), withdraw2faEnabled ? /*#__PURE__*/_react.default.createElement(_TwoFactorForm.TwoFactorForm, {
    onSubmit: props.onModalSubmit
  }, /*#__PURE__*/_react.default.createElement(Button, {
    color: "secondary",
    loading: props.modalSubmitLoading,
    disabled: props.modalSubmitDisabled,
    type: "submit",
    wide: true
  }, props.modalSubmitBtnText)) : /*#__PURE__*/_react.default.createElement(Button, {
    color: "secondary",
    loading: props.modalSubmitLoading,
    disabled: props.modalSubmitDisabled,
    onClick: function onClick() {
      return props.onModalSubmit({});
    },
    type: "submit",
    wide: true
  }, props.modalSubmitBtnText), /*#__PURE__*/_react.default.createElement(_transactionInfo.TransactionInfoAmountItem, {
    title: "".concat(balanceName, " ").concat(t('libCommon:balance').toLowerCase(), " ").concat(t('after'), ":"),
    ticker: props.ticker,
    fiatTicker: props.fiatTicker,
    amount: props.balanceAfterTransaction,
    fiatTickerAmount: props.fiatBalanceAfterTransaction
  }), children, /*#__PURE__*/_react.default.createElement(StyledAlert, {
    component: _ui.ExtraSmall
  }, t(props.isFiat ? 'libTransfers:sendFiatAttention' : 'libTransfers:sendAttention'))));
};
exports.ConfirmModal = ConfirmModal;